import { MdAccountCircle } from 'react-icons/md';

const TopNavBar = (props) => {

  const _doSignOut = () => {
    localStorage.removeItem('token');
    props.handleUpdate({ updateType : 'checkIsSignedIn' });
  };
    

  return (
    <nav className="navbar navbar-expand-lg" style={{ backgroundColor : '#009fe3', position : 'fixed', top : 5, left : 230, right : 5, height : 40, zIndex : 10000, borderRadius: 5, boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.4)' }}>
      <div className="container-fluid">
        <a className="navbar-brand text-white" href="#"></a>
  
        <div className="" id="navbarMenu">
          <ul className="navbar-nav ms-auto">
            {/*
            <li className="nav-item">
              <a className="nav-link active" href="#">Home</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#">About</a>
            </li>
            */}

            {/*
            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle" href="#" role="button"
                 data-bs-toggle="dropdown" aria-expanded="false">
                Services
              </a>
              <ul className="dropdown-menu dropdown-menu-end">
                <li><a className="dropdown-item" href="#">Web Design</a></li>
                <li><a className="dropdown-item" href="#">Development</a></li>
                <li><a className="dropdown-item" href="#"  onClick = { _doSignOut } >Sign out</a></li>
              </ul>
            </li>
            */}
            <li className="nav-item" style={{ marginLeft : 0, paddingLeft : 0 }}>
              <a className="nav-link active text-white" style={{ fontSize: '0.9em' }} href="#" onClick = { _doSignOut } onPress = { _doSignOut }>Sign out</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );

};

export default TopNavBar;

